module.exports = __webpack_public_path__ + "img/b_kudamfb@2x.976aabd9.png";